module.exports = __webpack_public_path__ + "bbd24b99e60d78d9f8300aebbf579a7e.fbx";